import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import minicartQuery from '~/graphql/cart/minicart.gql';
import createNewCartMutation from '~/graphql/cart/createNewCart.gql';
import addProductsToCartMutation from '~/graphql/cart/addProductsToCart.gql';
import addCustomizableProductToCartMutation from '~/graphql/cart/addCustomizableProductToCart.gql';
import updateCartMutation from '~/graphql/cart/updateCart.gql';

function fetchCart(_x, _x2, _x3) {
  return _fetchCart.apply(this, arguments);
}

function _fetchCart() {
  _fetchCart = _asyncToGenerator(function* (context, reference, token) {
    const data = yield context.app.apolloProvider.defaultClient.query(_objectSpread({
      query: minicartQuery,
      errorPolicy: 'all',
      fetchPolicy: 'network-only'
    }, token && {
      context: {
        headers: {
          Authorization: "Bearer ".concat(token)
        }
      }
    }, {
      variables: {
        reference
      }
    }));
    return data;
  });
  return _fetchCart.apply(this, arguments);
}

function createCart(_x4, _x5) {
  return _createCart.apply(this, arguments);
}

function _createCart() {
  _createCart = _asyncToGenerator(function* (context, token) {
    const {
      data
    } = yield context.app.apolloProvider.defaultClient.mutate(_objectSpread({
      mutation: createNewCartMutation
    }, token && {
      context: {
        headers: {
          Authorization: "Bearer ".concat(token)
        }
      }
    }));
    return data;
  });
  return _createCart.apply(this, arguments);
}

function addCart(_x6, _x7) {
  return _addCart.apply(this, arguments);
}

function _addCart() {
  _addCart = _asyncToGenerator(function* (context, payload) {
    const response = yield context.app.apolloProvider.defaultClient.mutate(_objectSpread({
      mutation: addProductsToCartMutation
    }, payload.token && {
      context: {
        headers: {
          Authorization: "Bearer ".concat(payload.token)
        }
      }
    }, {
      variables: {
        cart: payload.cart,
        products: [_objectSpread({
          reference: payload.reference,
          quantity: payload.quantity
        }, payload.offer && {
          offer: payload.offer
        })]
      }
    }));
    return response;
  });
  return _addCart.apply(this, arguments);
}

function addCartCustomizable(_x8, _x9, _x10, _x11) {
  return _addCartCustomizable.apply(this, arguments);
}

function _addCartCustomizable() {
  _addCartCustomizable = _asyncToGenerator(function* (context, cart, token, payload) {
    const {
      data
    } = yield context.app.apolloProvider.defaultClient.mutate(_objectSpread({
      mutation: addCustomizableProductToCartMutation
    }, token && {
      context: {
        headers: {
          Authorization: "Bearer ".concat(token)
        }
      }
    }, {
      variables: {
        cart,
        reference: payload
      }
    }));
    return data;
  });
  return _addCartCustomizable.apply(this, arguments);
}

function updateCart(_x12, _x13) {
  return _updateCart.apply(this, arguments);
}

function _updateCart() {
  _updateCart = _asyncToGenerator(function* (context, payload) {
    const {
      data
    } = yield context.app.apolloProvider.defaultClient.mutate(_objectSpread({
      mutation: updateCartMutation
    }, payload.token && {
      context: {
        headers: {
          Authorization: "Bearer ".concat(payload.token)
        }
      }
    }, {
      variables: {
        cart: payload.cart,
        items: [{
          reference: payload.reference,
          quantity: payload.quantity
        }]
      }
    }));
    return data;
  });
  return _updateCart.apply(this, arguments);
}

export { fetchCart, createCart, addCart, updateCart, addCartCustomizable };